var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navmenu"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'classIndex', params: { id: 1 } }}},[_c('img',{staticClass:"navmenuimg",attrs:{"src":_vm.src}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68bbae76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexBanner.vue
// module id = null
// module chunks = 